import { Component, Input, OnDestroy, OnInit, Output, EventEmitter } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatProgressBar } from '@angular/material/progress-bar';
import { interval, Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-session-timer',
    imports: [
        MatIcon,
        MatProgressBar
    ],
    templateUrl: './session-timer.component.html',
    styleUrl: './session-timer.component.css'
})
export class SessionTimerComponent implements OnInit, OnDestroy {

  @Input() initialTime!: number;
  @Output() sessionExpired = new EventEmitter<void>();
  remainingTime!: number;
  private destroy$ = new Subject<void>();

  ngOnInit() {
    this.remainingTime = this.initialTime * 60;
    this.startCountdown();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private startCountdown(): void {
    interval(1000)
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        if (this.remainingTime > 0) {
          this.remainingTime--;
        } else {
          this.sessionExpired.emit();
          this.destroy$.next();
        }
      });
  }

  get progressPercentage(): number {
    return (this.remainingTime / (this.initialTime * 60)) * 100;
  }

  get formattedTime(): string {
    const minutes = Math.floor(this.remainingTime / 60);
    const seconds = this.remainingTime % 60;
    return `${this.pad(minutes)}:${this.pad(seconds)}`;
  }

  private pad(value: number): string {
    return value < 10 ? '0' + value : value.toString();
  }

}
